var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Mark Shipment Invalid On child Level")])])])]), _vm._v(" "), _c('b-card', [_c('form', {
    attrs: {
      "data-vv-scope": "markchildinvalidform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("AWB No.:")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "11px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-cart'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumber),
      expression: "awbnumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbnumber')
    },
    attrs: {
      "type": "text",
      "placeholder": "Please enter AWB Number",
      "name": "awbnumber",
      "id": "awbnumber"
    },
    domProps: {
      "value": (_vm.awbnumber)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('markchildinvalidform.awbnumber')),
      expression: "errors.has('markchildinvalidform.awbnumber')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter AWB\n              No.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "top": "-6px"
    }
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getMPSList
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n                Search")]), _vm._v("   \n              "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMPSList),
      expression: "showMPSList"
    }],
    staticClass: "form-group-row"
  }, [_c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "400px"
    }
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Sr No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("MPS No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Comment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Mark Invalid\n              ")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.tableData), function(data, index) {
    return [_c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.comments[index]),
        expression: "comments[index]"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "pattern": "/^.{1,500}$",
        "placeholder": "Enter Comments",
        "id": _vm.setname(index, 'comments'),
        "name": _vm.setname(index, 'comments')
      },
      domProps: {
        "value": (_vm.comments[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.comments, index, $event.target.value)
        }
      }
    })])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "checkbox",
      staticStyle: {
        "margin-left": "7.8rem"
      }
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedMPS[index]),
        expression: "selectedMPS[index]"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.setname(index, 'selectedMPS'),
        "name": _vm.setname(index, 'selectedMPS')
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.selectedMPS[index]) ? _vm._i(_vm.selectedMPS[index], data) > -1 : (_vm.selectedMPS[index])
      },
      on: {
        "change": function($event) {
          _vm.check($event)
        },
        "__c": function($event) {
          var $$a = _vm.selectedMPS[index],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedMPS[index] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedMPS[index] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.selectedMPS, index, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr"
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])])], 1)])]
  })], 2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("\n          Update")])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.showMPSInvalid = false
      }
    },
    model: {
      value: (_vm.showMPSInvalid),
      callback: function($$v) {
        _vm.showMPSInvalid = $$v
      },
      expression: "showMPSInvalid"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Mark MPS Invalid")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeShowMPSInvalid
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MPS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")])])]), _vm._v(" "), _vm._l((_vm.finalresult), function(item) {
    return _c('tbody', [_c('tr', {
      staticClass: "text-primary",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.data))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(item.message))])])])
  })], 2)])])])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c33b762","hasScoped":true}!./src/modules/utility/views/Markshipmentinvalidonchild/Markshipmentinvalidonchild.component.html
// module id = 2149
// module chunks = 3